import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Ad placeholder that only renders when the admin has enabled ads
 * (site settings → ads_enabled). Uses a module-level cache so
 * multiple AdSlots on the same page make a single network call.
 */
let _adsEnabledPromise = null;

function fetchAdsEnabled() {
  if (!_adsEnabledPromise) {
    _adsEnabledPromise = api
      .get("/settings/public")
      .then((r) => !!r.data?.ads_enabled)
      .catch(() => false);
  }
  return _adsEnabledPromise;
}

export default function AdSlot({ id = "ad", label = "विज्ञापन (Advertisement)", height = "h-24" }) {
  const [show, setShow] = useState(null); // null = loading, bool = decided
  useEffect(() => {
    let alive = true;
    fetchAdsEnabled().then((v) => { if (alive) setShow(v); });
    return () => { alive = false; };
  }, []);

  if (!show) return null;
  return (
    <div
      data-testid={`ad-slot-${id}`}
      className={`w-full ${height} my-6 border border-dashed border-slate-300 bg-slate-50 flex items-center justify-center rounded-lg text-xs text-slate-500 font-medium`}
      aria-label="Ad placeholder"
    >
      {label}
    </div>
  );
}
